import { render, staticRenderFns } from "./AboutElectoralCollege.vue?vue&type=template&id=d7968f7a&scoped=true&"
import script from "./AboutElectoralCollege.vue?vue&type=script&lang=js&"
export * from "./AboutElectoralCollege.vue?vue&type=script&lang=js&"
import style0 from "./AboutElectoralCollege.vue?vue&type=style&index=0&id=d7968f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7968f7a",
  null
  
)

export default component.exports